import styles from "./PdfDownloadButton.module.css";

interface PdfDownloadButtonProps {
  onClick?: () => void;
}

export function PdfDownloadButton({ onClick }: PdfDownloadButtonProps) {
  return (
    <div className={`${styles.wrapper} no-print`}>
      <button
        type="button"
        className={styles.button}
        onClick={onClick}
        aria-label="PDF 다운로드"
      >
        <svg
          className={styles.icon}
          viewBox="0 0 48 56"
          preserveAspectRatio="xMaxYMid meet"
          aria-hidden="true"
          focusable="false"
        >
          <defs>
            <linearGradient
              id="pdf-document-gradient"
              x1="0"
              y1="0"
              x2="0"
              y2="1"
            >
              <stop
                offset="0"
                stopColor="#ff3540"
              />
              <stop
                offset="1"
                stopColor="#ed0d1c"
              />
            </linearGradient>
            <linearGradient
              id="pdf-fold-gradient"
              x1="0"
              y1="0"
              x2="1"
              y2="1"
            >
              <stop
                offset="0"
                stopColor="#fff1f2"
              />
              <stop
                offset="1"
                stopColor="#ffc7cb"
              />
            </linearGradient>
          </defs>
          <rect
            className={styles.documentBase}
            x="6"
            y="4"
            width="42"
            height="51"
            rx="7"
          />
          <path
            className={styles.document}
            d="M13 2h22l13 13v33a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6V9a7 7 0 0 1 7-7Z"
          />
          <path
            className={styles.fold}
            d="M35 2v9a5 5 0 0 0 5 5h8Z"
          />
          <path
            className={styles.divider}
            d="M7 31h40"
          />
          <text
            className={styles.pdfText}
            x="27"
            y="27"
            textAnchor="middle"
          >
            PDF
          </text>
          <path
            className={styles.arrow}
            d="M27 36v11m-7-6 7 7 7-7"
          />
        </svg>
      </button>
    </div>
  );
}
